import utils from 'core/pkg/utils'

export default {
  init() {
    return utils
  }
}
